import { Input, Table } from "antd";
import React from "react";
import { peremeshenieData } from "../Form/formData";
import { newData } from "../Form/TableData";
import AddModal from "../Modal";
import { tableData } from "./TablData";

function SkladP() {
  const columns = [
    {
      title: "#",
      dataIndex: "key",
    },
    {
      title: "Data",
      dataIndex: "data",
    },
    {
      title: "Skladdan",
      dataIndex: "skladdan",
    },
    {
      title: "Skladga",
      dataIndex: "sklad",
    },
    {
      title: "Kol-bo",
      dataIndex: "kol-bo",
    },
    {
      title: "Kommentarii",
      dataIndex: "kommentarii",
    },
  ];

  return (
    <>
      <AddModal
        title={"Перемешение"}
        stil={"stil"}
        width={1400}
        columnsAll={peremeshenieData[0].columns}
        columnsAll2={peremeshenieData[0].columns1}
        form={peremeshenieData}
        table={newData}
        button={true}
      />
      <div className="mt-2">
        <Table columns={columns} />
      </div>
    </>
  );
}

export default SkladP;
